import React, { useState } from "react";
import Layout from "../form-layout";
import { GLP1_MEDICATIONS } from "../../data/eligibility-rules";

// Q14 — "What was your weight before starting [medication]?"
export default function Step14({ formData, setFormData, onBack, goToStep }) {
  const [weight, setWeight] = useState(formData.glp1PriorWeight || "");
  const medLabel =
    GLP1_MEDICATIONS.find((m) => m.key === formData.glp1TriedMedication)?.label || "that medication";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!weight) return;

    setFormData((prev) => ({ ...prev, glp1PriorWeight: weight }));
    localStorage.setItem("glp1PriorWeight", weight);

    goToStep("15");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        What was your weight before starting {medLabel}?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="number"
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
          placeholder="Weight (kg)"
          className="border-2 border-sky-300 rounded-xl p-3 focus:outline-none focus:ring-2 focus:ring-[#35C3D9]"
        />

        <div className="flex justify-start">
          <button
            type="submit"
            disabled={!weight}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${!weight ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"}`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
